import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import "rxjs/add/operator/map";

@Injectable({
  providedIn: "root",
})
export class BucketService {
  public bucket = {
    bucket_id:null, name:null, acces_key:null, secret_key:null, company_token:null, endpoint:null, company_id:null
  };

  constructor(private httpClient: HttpClient) {

  }

  loadBucketData(){
    //console.log("bucket")
    return this.httpClient
      .get(environment.api.bucketapi)
      .map((data) => data);

  }
}
/*export const SES={
    accesKey:"AKIAZI5VJPNY3FWCZSNA",
    secretKey:'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',

}*/
